<template>
  <div class="app-container">
    <ThreeBackground/>
    
    <div class="navigation">
      <TopNavigation title="Azad Barkho" :items="[{name:'Home',isActive:true},{name:'About',isActive:false}]" />
      <!--<TopNavigation title="Azad Barkho" :items="[{name:'Home',isActive:true},{name:'About',isActive:false}]" />-->
    </div>
    
    <div class="content">
      <router-view></router-view>
    </div>

    <div class="footer">
      <FooterComponent/>
    </div>
  </div>
</template>

<script>
import TopNavigation from './components/TopNavigation.vue';
import ThreeBackground from './components/ThreeBackground.vue';
import FooterComponent from './components/FooterComponent.vue';

export default {
  name: 'App',
  components: {
    TopNavigation,
    ThreeBackground,
    FooterComponent,
  }
};
</script>

<style scoped>
.app-container{
  width: 100%;
  height: 100%;

  .content{
    overflow-y: scroll;
    height: 80%;
    padding: 200px 0px;
  }
  .navigation{
    height: 10%;
  }
  .footer{
    height: 10%;
  }
}
</style>
